import React from 'react';
import { useShowContextRequired } from 'ui-builder';

import styles from './IsBusinessDay.module.scss';

export default function IsBusinessDay() {
  const showContext = useShowContextRequired<{
    useBusinessDaysCalculation: boolean
  }>();


  if (showContext.data!.useBusinessDaysCalculation) {
    return (
      <img src={'/img/business_day.png'} className={styles.icon} alt="Icon" />
    )
  } else {
    return null;
  }
}
